import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { UnauthorizedPageComponent } from './pages/unauthorized-page/unauthorized-page.component';
import { PageNotFoundPageComponent } from './pages/page-not-found-page/page-not-found-page.component';
import { ServerErrorPageComponent } from './pages/server-error-page/server-error-page.component';
import { ModelViewComponent } from './pages/model-view/model-view.component';
import { FolderViewComponent } from './pages/model-view/folder-view/folder-view.component';

export const routes: Routes = [
	{ path: '', component: HomePageComponent },
	{ path: 'model-view', component: ModelViewComponent },
	{ path: 'folder-view', component: FolderViewComponent },
	{ path: '403', component: UnauthorizedPageComponent },
	{ path: '401', component: UnauthorizedPageComponent },
	{ path: '404', component: PageNotFoundPageComponent },
	{ path: '500', component: ServerErrorPageComponent },
	{ path: '**', redirectTo: '404' }
];
